<div class="page-header">
  <div class="header-content">
    <div class="scheme-info">
      <h2 class="scheme-name">iDEX > Review Module</h2>
    </div>
      
  </div>
</div>
<!-- Dashboard Cards -->
<div class="row mb-4" *ngIf="dashboardStats">
  <div class="col-xl-3 col-md-6 mb-4">
    <div class="card border-left-primary shadow h-100 py-2">
      <div class="card-body">
        <div class="row no-gutters align-items-center">
          <div class="col mr-2">
            <div class="text-xs font-weight-bold text-primary text-uppercase mb-1">
              Ongoing Proposals</div>
            <div class="h5 mb-0 font-weight-bold text-gray-800">{{ dashboardStats.ongoingProposals }}</div>
          </div>
          <div class="col-auto">
            <i class="fas fa-clipboard-list fa-2x text-gray-300"></i>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="col-xl-3 col-md-6 mb-4">
    <div class="card border-left-success shadow h-100 py-2">
      <div class="card-body">
        <div class="row no-gutters align-items-center">
          <div class="col mr-2">
            <div class="text-xs font-weight-bold text-success text-uppercase mb-1">
              Reviews This Month</div>
            <div class="h5 mb-0 font-weight-bold text-gray-800">{{ dashboardStats.reviewsThisMonth }}</div>
          </div>
          <div class="col-auto">
            <i class="fas fa-search fa-2x text-gray-300"></i>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="col-xl-3 col-md-6 mb-4">
    <div class="card border-left-warning shadow h-100 py-2">
      <div class="card-body">
        <div class="row no-gutters align-items-center">
          <div class="col mr-2">
            <div class="text-xs font-weight-bold text-warning text-uppercase mb-1">
              Pending Tasks</div>
            <div class="h5 mb-0 font-weight-bold text-gray-800">{{ dashboardStats.pendingTasks }}</div>
          </div>
          <div class="col-auto">
            <i class="fas fa-tasks fa-2x text-gray-300"></i>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="col-xl-3 col-md-6 mb-4">
    <div class="card border-left-info shadow h-100 py-2">
      <div class="card-body">
        <div class="row no-gutters align-items-center">
          <div class="col mr-2">
            <div class="text-xs font-weight-bold text-info text-uppercase mb-1">
              Directorates Involved</div>
            <div class="h5 mb-0 font-weight-bold text-gray-800">{{ dashboardStats.directoratesInvolved }}</div>
          </div>
          <div class="col-auto">
            <i class="fas fa-building fa-2x text-gray-300"></i>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>


<div class="card container-fluid py-4">
  <!-- Tabs -->
  <ul class="nav nav-tabs" id="myTab" role="tablist">
    <li class="nav-item" role="presentation">
      <button class="nav-link" [class.active]="activeTab === 'dashboard'" (click)="setActiveTab('dashboard')"
        type="button">
        <i class="fas fa-tachometer-alt me-1"></i> Dashboard & Select for Review
      </button>
    </li>
    <li class="nav-item" role="presentation">
      <button class="nav-link" [class.active]="activeTab === 'send'" (click)="setActiveTab('send')" type="button">
        <i class="fas fa-paper-plane me-1"></i> Review
      </button>
    </li>
    <!-- <li class="nav-item" role="presentation">
      <button class="nav-link" [class.active]="activeTab === 'action'" (click)="setActiveTab('action')" type="button">
        <i class="fas fa-tasks me-1"></i> Action Points
      </button>
    </li> -->
    <li class="nav-item" role="presentation">
      <button class="nav-link" [class.active]="activeTab === 'status'" (click)="setActiveTab('status')" type="button">
        <i class="fas fa-chart-line me-1"></i> Review Status
      </button>
    </li>
  </ul>



  <div class="tab-content" id="myTabContent">
    <!-- Dashboard & Select for Review Tab -->
    <div class="tab-pane fade" [class.show]="activeTab === 'dashboard'" [class.active]="activeTab === 'dashboard'"
      role="tabpanel">
      <div class="row mb-4">
        <!-- Review Statistics Chart -->
        <!-- <div class="col-md-6">
          <div class="card h-100">
            <div class="card-header d-flex justify-content-between align-items-center">
              <h5 class="mb-0">Review Statistics</h5>
              <span class="badge bg-primary">This Month</span>
            </div>
            <div class="card-body d-flex justify-content-center align-items-center">
              <p-chart type="doughnut" [data]="reviewData" [options]="reviewOptions"
                style="width: 250px; height: 250px;">
              </p-chart>
            </div>
            <div class="card-footer bg-transparent">
              <div class="row text-center">
                <div class="col-3">
                  <small class="text-muted d-block">Completed</small>
                  <strong class="text-success">12</strong>
                </div>
                <div class="col-3">
                  <small class="text-muted d-block">In Progress</small>
                  <strong class="text-warning">8</strong>
                </div>
                <div class="col-3">
                  <small class="text-muted d-block">Pending</small>
                  <strong class="text-info">5</strong>
                </div>
                <div class="col-3">
                  <small class="text-muted d-block">Not Started</small>
                  <strong class="text-secondary">3</strong>
                </div>
              </div>
            </div>
          </div>
        </div> -->

        <!-- Upcoming Reviews -->
        <!-- <div class="col-md-6">
          <div class="card h-100">
            <div class="card-header d-flex justify-content-between align-items-center">
              <h5 class="mb-0">Upcoming Reviews</h5>
              <span class="badge bg-warning">{{ upcomingReviews.length }} Scheduled</span>
            </div>
            <div class="card-body p-0">
              <div class="list-group list-group-flush">
                <div class="list-group-item d-flex justify-content-between align-items-start px-3 py-2"
                  *ngFor="let review of upcomingReviews; let i = index"
                  [class.border-bottom]="i !== upcomingReviews.length - 1">
                  <div class="flex-grow-1">
                    <div class="d-flex justify-content-between align-items-center mb-1">
                      <h6 class="mb-0 text-primary">{{ review.srNo }}</h6>
                      <span class="badge" [ngClass]="{
                          'bg-danger': review.dueDate === 'Tomorrow',
                          'bg-warning': review.dueDate === 'In 3 days',
                          'bg-info': review.dueDate === 'Next week'
                        }">
                        {{ review.dueDate }}
                      </span>
                    </div>
                    <p class="mb-1 fw-semibold">{{ review.name }}</p>
                    <p class="mb-0 text-muted small">{{ review.description }}</p>
                  </div>
                </div>
              </div>
            </div>
            <div class="card-footer bg-transparent text-center">
              <a href="#" class="text-decoration-none small">
                <i class="fas fa-calendar-alt me-1"></i>View All Scheduled Reviews
              </a>
            </div>
          </div>
        </div> -->
      </div>

      <div class="selection-panel">
        <div class="row align-items-center">
          <div class="col-md-8">
            <h5 class="mb-2">Select Proposals for Review</h5>
            <p class="mb-0 text-muted">
              <i class="fas fa-info-circle me-1"></i>
              Select proposals based on: <strong>Nearing Milestones</strong> / <strong>Review Not Yet Done</strong> /
              <strong>Both</strong>
            </p>
          </div>
          <div class="col-md-4 text-end">
            <button class="btn btn-primary" (click)="proceedToReview()" [disabled]="selectedProposals.length === 0">
              <i class="fas fa-arrow-right me-1"></i> Proceed to Review
              <span *ngIf="selectedProposals.length > 0" class="badge bg-light text-dark ms-1">
                {{ selectedProposals.length }}
              </span>
            </button>
          </div>
        </div>
      </div>

      <div class="card">
        <div class="card-header d-flex justify-content-between align-items-center">
          <h5 class="mb-0">Ongoing Proposals</h5>
          <div class="d-flex gap-2 align-items-center">
            <!-- Selection Buttons -->
            <div class="btn-group">
              <button class="btn btn-outline-primary btn-sm" (click)="selectAllProposals()"
                [disabled]="filteredProposals.length === 0">
                <i class="fas fa-check-square me-1"></i> Select All
              </button>
              <button class="btn btn-outline-secondary btn-sm" (click)="deselectAllProposals()"
                [disabled]="filteredProposals.length === 0">
                <i class="fas fa-times-circle me-1"></i> Deselect All
              </button>
            </div>

            <!-- ... (rest of your header controls remain the same) ... -->
          </div>
        </div>
        <div class="card-body">
          <!-- ... (filter status section remains the same) ... -->

          <!-- PrimeNG Table -->
          <div class="table-responsive">
            <p-table [value]="filteredProposals" [paginator]="true" [rows]="10" [rowsPerPageOptions]="[10, 25, 50]"
              [totalRecords]="filteredProposals.length" [showCurrentPageReport]="true"
              currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
              [tableStyle]="{'min-width': '75rem'}" styleClass="p-datatable-striped p-datatable-gridlines">

              <ng-template pTemplate="header">
                <tr>
                  <th style="width: 50px">
                    <input class="form-check-input" type="checkbox"
                      [checked]="areAllFilteredSelected() && filteredProposals.length > 0"
                      (change)="areAllFilteredSelected() ? deselectAllProposals() : selectAllProposals()"
                      [disabled]="filteredProposals.length === 0">
                  </th>
                  <th style="width: 100px">SR No</th>
                  <th>Scheme Name</th>
                  <th>Proposal Name</th>
                  <th>Challenge Name</th>
                  <th>Last Review</th>
                  <th>Closest Milestone</th>
                  <th>Days Remaining</th>
                  <th>Selection Criteria</th>
                  <th style="width: 120px">Actions</th>
                </tr>
              </ng-template>

              <ng-template pTemplate="body" let-proposal let-rowIndex="rowIndex">
                <tr [class.table-primary]="proposal.selected">
                  <td>
                    <input class="form-check-input" type="checkbox" [checked]="proposal.selected"
                      (change)="toggleProposalSelection(proposal)">
                  </td>
                  <td><strong>{{ rowIndex + 1 }}</strong></td>
                  <td>
                    <div class="fw-semibold">{{ proposal.scheme_name || '-' }}</div>
                  </td>
                  <td>
                    <div class="fw-semibold">{{ proposal.proposal_name || '-' }} </div>
                  </td>
                  <td>
                    <span class="text-truncate d-inline-block" style="max-width: 200px;"
                      [pTooltip]="proposal.description" tooltipPosition="top">
                      {{ proposal.challenge || '-'}}
                    </span>
                  </td>
                  <td>{{ proposal.review_date || '-' }}</td>
                  <td>
                    <span class="badge bg-light text-dark border">
                      {{ proposal.closestMilestone || '-'}}
                    </span>
                  </td>
                  <td>
                    <span class="badge" [ngClass]="getBadgeClass(proposal.daysRemaining)">
                      {{ proposal.daysRemaining || '-'}} days
                    </span>
                  </td>
                  <td>
                    <span class="badge criteria-badge" [ngClass]="getCriteriaBadgeClass(proposal.selectionCriteria)">
                      {{ proposal.selectionCriteria || '-' }}
                    </span>
                  </td>
                  <td>
                    <button class="btn btn-sm btn-outline-info" (click)="viewProposalDetails(proposal)"
                      pTooltip="View Details" tooltipPosition="top">
                      <i class="fas fa-eye me-1"></i>View
                    </button>
                  </td>
                </tr>
              </ng-template>

              <ng-template pTemplate="emptymessage">
                <tr>
                  <td colspan="9" class="text-center py-5">
                    <i class="fas fa-inbox fa-3x text-muted mb-3"></i>
                    <h5 class="text-muted">No proposals found</h5>
                    <p class="text-muted" *ngIf="filterCriteria !== 'all' || searchTerm">
                      Try adjusting your filters or search criteria
                    </p>
                    <button class="btn btn-primary mt-2" *ngIf="filterCriteria !== 'all' || searchTerm"
                      (click)="clearFilters()">
                      Clear Filters
                    </button>
                  </td>
                </tr>
              </ng-template>

              <ng-template pTemplate="paginatorleft">
                <span class="text-muted">
                  Showing {{ filteredProposals.length }} of {{ totalRecords }} proposals •
                  <strong class="text-primary">{{ getSelectedCount() }} selected</strong>
                </span>
              </ng-template>
            </p-table>
          </div>
        </div>
      </div>
      <div *ngIf="selectedProposalDetails" class="proposal-details-section">
        <div class="proposal-details-header">
          <div class="proposal-details-title">
            <i class="pi pi-file-text"></i>
            <h4>Proposal Details</h4>
          </div>
          <p class="proposal-details-subtitle">Detailed information about the selected proposal</p>
        </div>

        <div class="proposal-details-content">
          <!-- Basic Proposal Info -->
          <div class="proposal-basic-info">
            <div class="row mb-2">
              <div class="col-md-6">
                <strong>Proposal Name:</strong>
                <div class="action-point-value">{{ selectedProposalDetails.proposal_name || '—' }}</div>
              </div>
              <div class="col-md-6">
                <strong>Challenge:</strong>
                <div class="action-point-value">{{ selectedProposalDetails.challenge || '—' }}</div>
              </div>
            </div>

            <div class="row mb-2">
              <div class="col-md-6">
                <strong>Scheme:</strong>
                <div class="action-point-value">{{ selectedProposalDetails.scheme_name || '—' }}</div>
              </div>
              <div class="col-md-6">
                <strong>Status:</strong>
                <span class="badge" [ngClass]="{
                'bg-success': selectedProposalDetails.status === 1,
                'bg-warning': selectedProposalDetails.status === 0,
                'bg-secondary': !selectedProposalDetails.status
              }">
                  {{ selectedProposalDetails.status === 1 ? 'Active' : 'Inactive' }}
                </span>
              </div>
            </div>

            <div class="row mb-3">
              <div class="col-md-6">
                <strong>Assigned Date:</strong>
                <div class="action-point-value">{{ selectedProposalDetails.assigned_date || '—' }}</div>
              </div>
              <div class="col-md-6">
                <strong>Created On:</strong>
                <div class="action-point-value">{{ selectedProposalDetails.created_on | date: 'medium' }}</div>
              </div>
            </div>
          </div>

          <!-- Action Points Section -->
          <div class="action-points-section">
            <div class="action-points-header">
              <i class="pi pi-list"></i>
              <h6>Action Points</h6>
            </div>

            <ng-container *ngIf="actionPointList?.length; else noActions">
              <div *ngFor="let ap of actionPointList; let i = index" class="action-point-card">
                <div class="row">
                  <div class="col-md-1 text-center">
                    <div class="action-point-number">{{ i + 1 }}</div>
                  </div>
                  <div class="col-md-5">
                    <div class="action-point-label">Action Point:</div>
                    <div class="action-point-value">{{ ap.action_point || '—' }}</div>
                  </div>
                  <div class="col-md-3">
                    <div class="action-point-label">EDC:</div>
                    <div class="action-point-value">{{ ap.edc || '—' }}</div>
                  </div>
                  <div class="col-md-3">
                    <div class="action-point-label">Directorate:</div>
                    <div class="action-point-value">{{ ap.directorate || '—' }}</div>
                  </div>
                </div>
                <div class="row mt-2">
                  <div class="col-md-12">
                    <div class="action-point-label">Comment:</div>
                    <div class="action-point-value">{{ ap.comment || '—' }}</div>
                  </div>
                </div>
                <div *ngIf="ap.flag" class="action-point-flag">
                  <strong>Flag:</strong>
                  <span class="text-warning">{{ ap.flag }}</span>
                </div>
              </div>
            </ng-container>

            <ng-template #noActions>
              <div class="no-action-points">
                <i class="pi pi-inbox"></i>
                <p>No action points available for this proposal.</p>
              </div>
            </ng-template>
          </div>

          <!-- Close Button -->
          <div class="proposal-details-close">
            <button class="btn btn-outline-primary" (click)="closeProposalDetails()">Close</button>
          </div>
        </div>
      </div>
    </div>

    <!-- Send for Review Tab -->
    <div class="tab-pane fade" [class.show]="activeTab === 'send'" [class.active]="activeTab === 'send'"
      role="tabpanel">
      <div *ngIf="selectedProposals?.length > 0; else noSelection">
        <h5 class="mb-3">Selected Proposals for Review</h5>

        <div *ngFor="let proposal of selectedProposals" class="mb-4">
          <div class="card shadow-sm">
            <div class="card-header d-flex justify-content-between align-items-center">
              <h6 class="mb-0">
                {{ proposal.proposal_name }}
                <span class="text-muted">({{ proposal.scheme_name }})</span>
              </h6>
              <div class="d-flex justify-content-end gap-2">

                <button class="btn btn-sm btn-outline-primary" (click)="addActionPoint(proposal)">
                  <i class="fas fa-plus me-1"></i> Add Action Point
                </button>

                <button class="btn btn-sm btn-outline-primary" (click)="toggleActionPoints(proposal)">
                  <i class="fas me-1"
                    [ngClass]="showActionPoints && selectedProposalForActionPoints === proposal ? 'fa-eye-slash' : 'fa-eye'">
                  </i>

                  {{ showActionPoints && selectedProposalForActionPoints === proposal
                  ? 'Hide Action Points'
                  : 'View Action Points' }}
                </button>

              </div>
            </div>

            <div class="card-body">
              <div *ngIf="proposal.actionPoints?.length > 0; else noActionPoints">
                <p-table [value]="proposal.actionPoints" styleClass="p-datatable-sm p-datatable-striped">
                  <ng-template pTemplate="header">
                    <tr>
                      <th>#</th>
                      <th>Action Point</th>
                      <th>Action By</th>
                      <th>Due Date</th>
                      <th>Comments</th>
                      <th>Delete</th>
                    </tr>
                  </ng-template>

                  <ng-template pTemplate="body" let-ap let-i="rowIndex">
                    <tr>
                      <td>{{ i + 1 }}</td>
                      <td>
                        <textarea [(ngModel)]="ap.description" class="form-control form-control-sm"></textarea>
                      </td>
                      <td>
                        <p-dropdown [options]="directorates" optionLabel="name" optionValue="id"
                          [(ngModel)]="ap.actionBy" placeholder="Select" appendTo="body" styleClass="w-100">
                        </p-dropdown>
                      </td>
                      <td><input type="date" class="form-control form-control-sm" [(ngModel)]="ap.dueDate" /></td>
                      <td><input type="text" class="form-control form-control-sm" [(ngModel)]="ap.comments" /></td>
                      <td class="text-center">
                        <button class="btn btn-sm btn-outline-danger" (click)="removeActionPoint(proposal, ap.id)">
                          <i class="fas fa-trash"></i>
                        </button>
                      </td>
                    </tr>
                  </ng-template>
                </p-table>
              </div>

              <ng-template #noActionPoints>
                <div class="d-flex justify-content-center align-items-center gap-3 py-2 text-muted">

                  <span>Add action points yet.</span>

                  <input #rowInput class="form-control" style="width: 60px; height: 25px;" placeholder="Row"
                    (input)="generateActionRows(rowInput.value, proposal)" />

                </div>
              </ng-template>
              <!-- ACTION POINT DASHBOARD -->
              <div *ngIf="showActionPoints" class="mt-4">

                <div class="card">

                  <div class="card-header">
                    <h5 class="mb-0">
                      Action Points - {{ selectedProposalForActionPoints?.proposal_name }}
                    </h5>
                  </div>

                  <div class="card-body">

                    <!-- Summary -->
                    <div class="row mb-4">

                      <div class="col-md-3">
                        <div class="card text-center">
                          <div class="card-body">
                            <i class="fas fa-tasks mb-2"></i>
                            <h4>{{ getActionPointsCount() }}</h4>
                            <small>Total Assigned</small>
                          </div>
                        </div>
                      </div>

                      <div class="col-md-3">
                        <div class="card text-center">
                          <div class="card-body">
                            <i class="fas fa-exclamation-triangle text-danger mb-2"></i>
                            <h4>{{ getOverdueActionPointsCount() }}</h4>
                            <small>Overdue</small>
                          </div>
                        </div>
                      </div>

                      <div class="col-md-3">
                        <div class="card text-center">
                          <div class="card-body">
                            <i class="fas fa-check-circle text-success mb-2"></i>
                            <h4>{{ getCompletedActionPointsCount() }}</h4>
                            <small>Completed</small>
                          </div>
                        </div>
                      </div>

                      <div class="col-md-3">
                        <div class="card text-center">
                          <div class="card-body">
                            <i class="fas fa-sync-alt text-primary mb-2"></i>
                            <h4>{{ getInProgressActionPointsCount() }}</h4>
                            <small>In Progress</small>
                          </div>
                        </div>
                      </div>

                    </div>

                    <!-- Table -->
                    <div class="table-responsive">

         <p-table [value]="reviewActionPoints" styleClass="p-datatable-striped p-datatable-gridlines">

  <ng-template pTemplate="header">
    <tr>
      <th>S.No</th>
      <th>Action Point</th>
      <th>Priority</th>
      <th>Due Date</th>
      <th>Directorate</th>
      <th>Status</th>
      <th>Last Update</th>
    </tr>
  </ng-template>

  <ng-template pTemplate="body" let-actionPoint let-i="rowIndex">
    <tr>

      <td>{{ i + 1 }}</td>
      <td>{{ actionPoint.action_point }}</td>
      <td>{{ actionPoint.priority }}</td>
      <td>{{ formatDisplayDate(actionPoint.edc) }}</td>
      <td>{{ actionPoint.directorate }}</td>

      <td>
        <span class="badge" [ngClass]="getStatusBadgeClass(actionPoint.status)">
          {{ actionPoint.status }}
        </span>
      </td>

      <td>{{ formatDisplayDate(actionPoint.created_on) }}</td>

    </tr>
  </ng-template>

</p-table>

                    </div>

                  </div>

                </div>

              </div>
            </div>
          </div>
        </div>
      </div>

      <ng-template #noSelection>
        <div class="text-center py-4 text-muted">
          <i class="pi pi-info-circle me-1"></i> No proposals selected for review.
        </div>
      </ng-template>
      <div class="d-flex justify-content-between align-items-center mt-4"
        *ngIf="getSelectedProposalsWithActionPoints().length > 0">
        <div>
          <span class="text-muted">
            Total Proposals: <strong class="text-primary">{{ getSelectedProposalsWithActionPoints().length }}</strong> •
            Total Action Points: <strong class="text-primary">{{ actionPoints.length }}</strong>
          </span>
        </div>
        <div>
          <button class="btn btn-success me-2" (click)="saveActionPoints()">
            <i class="fas fa-save me-1"></i> Save All Action Points
          </button>
          <button class="btn btn-primary" (click)="submitForReview()" [disabled]="getTotalActionPointsCount() === 0">
            <i class="fas fa-paper-plane me-1"></i> Submit for Review
          </button>
        </div>
      </div>

      <!-- Navigation Buttons -->
      <div class="d-flex justify-content-between mt-4" *ngIf="getSelectedProposalsWithActionPoints().length === 0">
       <div class="d-flex justify-content-start gap-2 mb-3">

  <button class="btn btn-secondary" (click)="backToDashboard()">
    <i class="fas fa-arrow-left me-1"></i> Back to Dashboard
  </button>

  <button class="btn btn-secondary" (click)="backToMonitoring()">
    <i class="fas fa-arrow-left me-1"></i> Back to Monitoring
  </button>

</div>
        <button class="btn btn-success" (click)="submitForReview()" [disabled]="getTotalActionPointsCount() === 0">
          <i class="fas fa-paper-plane me-1"></i> Submit for Review
        </button>
      </div>
    </div>

    <!-- Action Points Tab -->


    <!-- Review Status Tab -->
    <div class="tab-pane fade" [class.show]="activeTab === 'status'" [class.active]="activeTab === 'status'"
      role="tabpanel">
      <div class="card">
        <div class="card-header">
          <h5 class="mb-0">Review Status - All Proposals</h5>
        </div>
        <div class="card-body">
          <!-- Summary Cards -->
          <div class="row mb-4">
            <div class="col-md-3">
              <div class="card bg-primary text-white">
                <div class="card-body text-center py-3">
                  <h4 class="mb-1">{{ getReviewStatusTotalActionPoints() }}</h4>
                  <small>Total Action Points</small>
                </div>
              </div>
            </div>
            <div class="col-md-3">
              <div class="card bg-warning text-dark">
                <div class="card-body text-center py-3">
                  <h4 class="mb-1">{{ getReviewStatusOverdueCount() }}</h4>
                  <small>Overdue</small>
                </div>
              </div>
            </div>
            <div class="col-md-3">
              <div class="card bg-success text-white">
                <div class="card-body text-center py-3">
                  <h4 class="mb-1">{{ getReviewStatusCompletedCount() }}</h4>
                  <small>Completed</small>
                </div>
              </div>
            </div>
            <div class="col-md-3">
              <div class="card bg-info text-white">
                <div class="card-body text-center py-3">
                  <h4 class="mb-1">{{ getReviewStatusInProgressCount() }}</h4>
                  <small>In Progress</small>
                </div>
              </div>
            </div>
          </div>

          <!-- Main Review Status Table -->
          <div class="table-responsive mb-4">
            <p-table [value]="reviewStatus" [tableStyle]="{'min-width': '75rem'}"
              styleClass="p-datatable-striped p-datatable-gridlines" selectionMode="single"
              [(selection)]="selectedReviewStatus">

              <ng-template pTemplate="header">
                <tr>
                  <th style="width: 80px">S.No</th>
                  <th style="width: 100px">SR No</th>
                  <th>Proposal Name</th>
                  <th style="width: 120px">Review Date</th>
                  <th style="width: 120px">Total Action Points</th>
                  <th style="width: 100px">Completed</th>
                  <th style="width: 100px">In Progress</th>
                  <th style="width: 100px">Pending</th>
                  <th style="width: 120px">Actions</th>
                </tr>
              </ng-template>

              <ng-template pTemplate="body" let-status let-rowIndex="rowIndex">
                <tr [pSelectableRow]="status">
                  <td class="text-center">
                    <strong>{{ rowIndex + 1 }}</strong>
                  </td>
                  <td><strong>{{ status.srNo }}</strong></td>
                  <td>{{ status.proposalName }}</td>
                  <td>{{ formatReviewStatusDate(status.reviewDate) }}</td>
                  <td>{{ status.totalActionPoints }}</td>
                  <td><span class="badge bg-success">{{ status.completed }}</span></td>
                  <td><span class="badge bg-warning">{{ status.inProgress }}</span></td>
                  <td><span class="badge bg-primary">{{ status.pending }}</span></td>
                  <td>
                    <button class="btn btn-sm btn-outline-primary" (click)="toggleReviewStatusDetails(status)"
                      [disabled]="selectedReviewStatus && selectedReviewStatus.srNo === status.srNo">
                      <i class="fas fa-eye me-1"></i>
                      {{ selectedReviewStatus && selectedReviewStatus.srNo === status.srNo ? 'Viewing' : 'View Details'
                      }}
                    </button>
                  </td>
                </tr>
              </ng-template>
            </p-table>
          </div>

          <!-- Review Details Section -->
          <div *ngIf="selectedReviewStatus" class="review-details-section">
            <div class="card">
              <div class="card-header bg-light d-flex justify-content-between align-items-center">
                <h6 class="mb-0">
                  <i class="fas fa-file-alt me-2"></i>
                  Review Details - {{ selectedReviewStatus.srNo }}: {{ selectedReviewStatus.proposalName }}
                </h6>
                <button class="btn btn-sm btn-outline-secondary" (click)="closeReviewStatusDetails()">
                  <i class="fas fa-times"></i> Close
                </button>
              </div>
              <div class="card-body">
                <!-- Header Summary -->
                <div class="row mb-4">
                  <div class="col-md-6">
                    <div class="detail-grid">
                      <div class="detail-item">
                        <label class="fw-semibold">Proposal Name:</label>
                        <span>{{ selectedReviewStatus.proposalName }}</span>
                      </div>
                      <div class="detail-item">
                        <label class="fw-semibold">Review Date:</label>
                        <span>{{ formatReviewStatusDate(selectedReviewStatus.reviewDate) }}</span>
                      </div>
                      <div class="detail-item">
                        <label class="fw-semibold">Review Type:</label>
                        <span class="badge bg-info">{{ selectedReviewStatus.reviewType }}</span>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class="detail-grid">
                      <div class="detail-item">
                        <label class="fw-semibold">Overall Status:</label>
                        <span class="badge"
                          [ngClass]="getReviewOverallStatusBadgeClass(selectedReviewStatus.overallStatus)">
                          {{ selectedReviewStatus.overallStatus }}
                        </span>
                      </div>
                      <div class="detail-item">
                        <label class="fw-semibold">Total Review Points:</label>
                        <span>{{ selectedReviewStatus.summary.total }}</span>
                      </div>
                      <div class="detail-item">
                        <label class="fw-semibold">Completion Rate:</label>
                        <span class="text-success fw-bold">
                          {{ (selectedReviewStatus.summary.completed / selectedReviewStatus.summary.total * 100) |
                          number:'1.0-0' }}%
                        </span>
                      </div>
                    </div>
                  </div>
                </div>

                <!-- Review Points Table with File Upload -->
                <div class="card">
                  <div class="card-header d-flex justify-content-between align-items-center">
                    <h6 class="mb-0">Review Points</h6>
                    <span class="badge bg-primary">{{ selectedReviewStatus.reviewPoints.length }} points</span>
                  </div>
                  <div class="card-body p-0">
                    <div class="table-responsive">
                      <p-table [value]="selectedReviewStatus.reviewPoints" [tableStyle]="{'min-width': '85rem'}"
                        styleClass="p-datatable-sm p-datatable-striped p-datatable-gridlines">

                        <ng-template pTemplate="header">
                          <tr>
                            <th style="width: 60px">S.No</th>
                            <th style="width: 80px">ID</th>
                            <th style="width: 120px">Category</th>
                            <th>Description</th>
                            <th style="width: 150px">Assigned To</th>
                            <th style="width: 120px">Due Date</th>
                            <th style="width: 120px">Status</th>
                            <th style="width: 120px">Last Updated</th>
                            <th style="width: 200px">Attachments</th>
                            <th style="width: 100px">Actions</th>
                          </tr>
                        </ng-template>

                        <ng-template pTemplate="body" let-point let-rowIndex="rowIndex">
                          <tr [class.table-success]="point.status === 'COMPLETED'"
                            [class.table-warning]="point.status === 'IN_PROGRESS'"
                            [class.table-secondary]="point.status === 'NOT_STARTED'">
                            <td class="text-center">
                              <strong>{{ rowIndex + 1 }}</strong>
                            </td>
                            <td><strong>{{ point.id }}</strong></td>
                            <td>
                              <span class="badge bg-light text-dark">{{ point.category }}</span>
                            </td>
                            <td>
                              <div class="fw-semibold">{{ point.description }}</div>
                              <small *ngIf="point.comments" class="text-muted">{{ point.comments }}</small>
                            </td>
                            <td>{{ point.assignedTo }}</td>
                            <td>
                              <span
                                [class.text-danger]="isReviewPointOverdue(point.dueDate) && point.status !== 'COMPLETED'">
                                {{ formatReviewStatusDate(point.dueDate) }}
                              </span>
                            </td>
                            <td>
                              <span class="badge" [ngClass]="getReviewPointStatusBadgeClass(point.status)">
                                {{ point.status }}
                              </span>
                            </td>
                            <td>{{ formatReviewStatusDate(point.lastUpdated) }}</td>
                            <td>
                              <div *ngIf="point.attachments && point.attachments.length > 0" class="file-attachments">
                                <div *ngFor="let file of point.attachments" class="file-item small">
                                  <i class="fas fa-paperclip me-1"></i>
                                  <span class="file-name">{{ file.name }}</span>
                                  <button class="btn btn-sm btn-outline-danger ms-1"
                                    (click)="removeReviewPointAttachment(point, file)" title="Remove file">
                                    <i class="fas fa-times"></i>
                                  </button>
                                </div>
                              </div>
                              <small *ngIf="!point.attachments || point.attachments.length === 0" class="text-muted">
                                No attachments
                              </small>
                            </td>
                            <td>
                              <button class="btn btn-sm btn-outline-primary"
                                (click)="toggleReviewPointFileUpload(point)" title="Upload Files">
                                <i class="fas fa-upload me-1"></i> Upload
                              </button>
                            </td>
                          </tr>

                          <!-- File Upload Section for this Review Point -->
                          <tr *ngIf="point.showFileUpload" class="file-upload-section">
                            <td colspan="10" class="bg-light">
                              <div class="p-3">
                                <h6 class="mb-3">Upload Files for Review Point: {{ point.id }}</h6>

                                <!-- File Upload Component -->
                                <app-upload-document></app-upload-document>
                                <!-- <p-fileUpload name="files[]" [multiple]="true" [customUpload]="true"
                                  (onSelect)="onReviewPointFileSelect($event, point)"
                                  (onRemove)="onReviewPointFileRemove($event, point)" chooseLabel="Select Files"
                                  chooseIcon="fas fa-paperclip" [showCancelButton]="false" [showUploadButton]="false"
                                  accept="image/*,.pdf,.doc,.docx,.xls,.xlsx,.ppt,.pptx" maxFileSize="10000000">
                                  <ng-template pTemplate="content">
                                    <div *ngIf="getReviewPointUploadedFiles(point).length" class="mt-3">
                                      <h6 class="mb-2">Selected Files:</h6>
                                      <div class="selected-files-list">
                                        <div *ngFor="let file of getReviewPointUploadedFiles(point)"
                                          class="file-item d-flex align-items-center justify-content-between p-2 border rounded mb-2">
                                          <div>
                                            <i class="fas fa-file me-2"></i>
                                            {{ file.name }}
                                            <small class="text-muted ms-2">({{ formatFileSize(file.size) }})</small>
                                          </div>
                                          <button type="button" class="btn btn-sm btn-outline-danger"
                                            (click)="removeReviewPointUploadedFile(point, file)">
                                            <i class="fas fa-times"></i>
                                          </button>
                                        </div>
                                      </div>
                                    </div>
                                  </ng-template>
                                </p-fileUpload> -->

                                <small class="text-muted d-block mt-2">
                                  Maximum file size: 10MB. Allowed formats: Images, PDF, Word, Excel, PowerPoint
                                </small>

                                <!-- Upload Actions -->
                                <div class="d-flex justify-content-between align-items-center mt-3">
                                  <div>
                                    <span class="text-muted">
                                      Files to upload: <strong class="text-primary">{{
                                        getReviewPointUploadedFiles(point).length }}</strong>
                                    </span>
                                  </div>
                                  <div>
                                    <button class="btn btn-secondary btn-sm me-2"
                                      (click)="cancelReviewPointFileUpload(point)">
                                      <i class="fas fa-times me-1"></i> Cancel
                                    </button>
                                    <button class="btn btn-primary btn-sm" (click)="uploadReviewPointFiles(point)"
                                      [disabled]="getReviewPointUploadedFiles(point).length === 0">
                                      <i class="fas fa-upload me-1"></i> Upload Files
                                    </button>
                                  </div>
                                </div>
                              </div>
                            </td>
                          </tr>
                        </ng-template>
                      </p-table>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>


<!-- Proposal Details Dialog -->
<!-- <p-dialog
  header="Proposal Details"
  [(visible)]="displayDialog"
  [modal]="true"
  [style]="{ width: '55vw' }"
  [draggable]="false"
  [resizable]="false"
>
  <div *ngIf="selectedProposalDetails" class="p-fluid">

    <div class="row mb-2">
      <div class="col-md-6">
        <strong>Proposal Name:</strong>
        {{ selectedProposalDetails.proposal_name || '—' }}
      </div>
      <div class="col-md-6">
        <strong>Challenge:</strong>
        {{ selectedProposalDetails.challenge || '—' }}
      </div>
    </div>

    <div class="row mb-2">
      <div class="col-md-6">
        <strong>Scheme:</strong>
        {{ selectedProposalDetails.scheme_name || '—' }}
      </div>
      <div class="col-md-6">
        <strong>Status:</strong>
        <span
          class="badge"
          [ngClass]="{
            'bg-success': selectedProposalDetails.status === 1,
            'bg-warning': selectedProposalDetails.status === 0,
            'bg-secondary': !selectedProposalDetails.status
          }"
        >
          {{ selectedProposalDetails.status === 1 ? 'Active' : 'Inactive' }}
        </span>
      </div>
    </div>

    <div class="row mb-3">
      <div class="col-md-6">
        <strong>Assigned Date:</strong> {{ selectedProposalDetails.assigned_date || '—' }}
      </div>
      <div class="col-md-6">
        <strong>Created On:</strong> {{ selectedProposalDetails.created_on | date: 'medium' }}
      </div>
    </div>

    <div class="action-points-section mt-3">
      <h6 class="mb-3"><i class="pi pi-list mr-2"></i>Action Points</h6>

      <ng-container *ngIf="actionPointList?.length; else noActions">
        <div
          *ngFor="let ap of actionPointList; let i = index"
          class="card mb-2 p-3 shadow-sm border-0"
          style="background: #f9f9f9; border-radius: 8px;"
        >
          <div class="row">
            <div class="col-md-1 text-center">
              <span class="badge bg-primary">{{ i + 1 }}</span>
            </div>
            <div class="col-md-5">
              <strong>Action Point:</strong> {{ ap.action_point || '—' }}
            </div>
            <div class="col-md-3">
              <strong>EDC:</strong> {{ ap.edc || '—' }}
            </div>
            <div class="col-md-3">
              <strong>Directorate:</strong> {{ ap.directorate || '—' }}
            </div>
          </div>
          <div class="row mt-2">
            <div class="col-md-12">
              <strong>Comment:</strong> {{ ap.comment || '—' }}
            </div>
          </div>
          <div *ngIf="ap.flag" class="row mt-1">
            <div class="col-md-12">
              <strong>Flag:</strong>
              <span class="text-warning">{{ ap.flag }}</span>
            </div>
          </div>
        </div>
      </ng-container>

      <ng-template #noActions>
        <p class="text-muted">No action points available for this proposal.</p>
      </ng-template>
    </div>
  </div>

  <ng-template pTemplate="footer">
    <button
      pButton
      type="button"
      label="Close"
      icon="pi pi-times"
      class="p-button-text"
      (click)="displayDialog = false"
    ></button>
  </ng-template>
</p-dialog> -->